export default __webpack_public_path__ + "6d84c6f70c770f17f814111b82f2737e.png";